import { useRouter } from "next/router";
import Machinary from "../Machinary";
import Cameras from "../Cameras";
import IrrigationNetwork from "../IrrigationNetwork";
import Fertigators from "../Fertigators";
import ElectricityNetwork from "../ElectricityNetwork";

export default function TabelsPages(props) {
  const router = useRouter();
  const SubCategorie = router.query;

  const subMachinary = [
    "tractor",
    "plower",
    "disk",
    "marker",
    "rotavator",
    "planter",
    "spreader",
    "sprayer",
    "opener",
    "digger",
    "harvester",
    "horsch-tiger",
  ];

  const SubIrrigationNetwork = [
    "center-pivot-farming/water-sources",
    "center-pivot-farming/pumps",
    "center-pivot-farming/flow-meters",
    "center-pivot-farming/pivots",
    "tree-farming/water-sources",
    "tree-farming/pump",
    "tree-farming/flow-meters",
    "tree-farming/pipes",
    "tree-farming/valves",
    "tree-farming/drips",
  ];

  const SubElectricityNetwork = ["electricity-source", "electricity-meters"];
  return (
    <div>
      {subMachinary.includes(`${SubCategorie.innerPage}`) && <Machinary />}
      {SubCategorie.pages === "cameras" && <Cameras />}
      {SubIrrigationNetwork.includes(
        `${SubCategorie.innerPage}/${SubCategorie.subInner}`
      ) && <IrrigationNetwork />}
      {SubCategorie.pages === "fertigators" && <Fertigators />}
      {SubElectricityNetwork.includes(`${SubCategorie.innerPage}`) && (
        <ElectricityNetwork />
      )}
    </div>
  );
}
